import React, { useState } from 'react';
import { BASE_URL } from "../../helpers/api";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading]     = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [errors, setErrors]       = useState({});
  const [apiError, setApiError]   = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear error on typing
    setErrors({ ...errors, [e.target.name]: '' });
  };

  // ✅ Validation
  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim())    newErrors.name    = 'Name is required';
    if (!formData.email.trim())   newErrors.email   = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
                                  newErrors.email   = 'Enter a valid email address';
    if (!formData.subject.trim()) newErrors.subject = 'Subject is required';
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError(null);

    // Run validation
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/contact/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setShowPopup(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        setErrors({});
      } else {
        setApiError(data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      console.error(err);
      setApiError('Server error. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ✅ Success Popup — matching appointment modal style */}
{showPopup && (
  <div className="modal-container">
    <button
      onClick={() => setShowPopup(false)}
      style={{
        position: "absolute", top: "10px", right: "10px",
        background: "transparent", border: "none",
        fontSize: "22px", cursor: "pointer", color: "gray", fontWeight: "normal",
      }}
    >
      ×
    </button>

    <div style={{ textAlign: "center", padding: "10px 0" }}>
      <div style={{ fontSize: "50px", marginBottom: "12px" }}></div>
      <h2 style={{
        color: "#0a6cff",
        fontSize: "22px",
        marginBottom: "10px",
        fontFamily: "Arial, sans-serif"
      }}>
        Thank You for Contacting Us!
      </h2>
      <p style={{
        color: "#555",
        fontSize: "14px",
        lineHeight: "1.6",
        marginBottom: "24px"
      }}>
        We have received your message and will get back to you within <strong>24 hours</strong>.
      </p>

      <button
        className="cs_btn cs_style_1"
        onClick={() => {
          setShowPopup(false);
          window.location.href = "/";
        }}
      >
        <span>Go to Home</span>
        <i>
          <img src="/images/icons/arrow_white.svg" alt="Icon" />
          <img src="/images/icons/arrow_white.svg" alt="Icon" />
        </i>
      </button>
    </div>
  </div>
)}

      {/* ✅ Contact Form */}
      <form
        className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30"
        onSubmit={handleSubmit}
      >
        {/* API Error */}
        {apiError && (
          <div style={{
            padding: '10px 14px',
            borderRadius: '6px',
            marginBottom: '16px',
            fontSize: '14px',
            backgroundColor: '#fff0f0',
            color: '#cc0000',
            border: '1px solid #ffcccc',
          }}>
             {apiError}
          </div>
        )}

        <div className="row">
          {/* NAME */}
          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">
              Name <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="cs_form_field"
              placeholder="David John"
              disabled={loading}
            />
            {errors.name && (
              <p style={{ color: 'red', fontSize: '14px', marginTop: '4px' }}>
                {errors.name}
              </p>
            )}
          </div>

          {/* EMAIL */}
          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">
              Email <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="cs_form_field"
              placeholder="example@gmail.com"
              disabled={loading}
            />
            {errors.email && (
              <p style={{ color: 'red', fontSize: '14px', marginTop: '4px' }}>
                {errors.email}
              </p>
            )}
          </div>

          {/* SUBJECT */}
          <div className="col-lg-12 mt-4">
            <label className="cs_input_label cs_heading_color">
              Subject <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className="cs_form_field"
              placeholder="Your subject"
              disabled={loading}
            />
            {errors.subject && (
              <p style={{ color: 'red', fontSize: '14px', marginTop: '4px' }}>
                {errors.subject}
              </p>
            )}
          </div>

          {/* MESSAGE */}
          <div className="col-lg-12 mt-4">
            <label className="cs_input_label cs_heading_color">
              Message <span style={{ color: 'red' }}>*</span>
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="cs_form_field"
              placeholder="Write something..."
              rows={5}
              disabled={loading}
            />
            {errors.message && (
              <p style={{ color: 'red', fontSize: '14px', marginTop: '4px' }}>
                 {errors.message}
              </p>
            )}
          </div>

          {/* SUBMIT */}
          <div className="col-lg-12 mt-4">
            <button
              type="submit"
              className="cs_btn cs_style_1"
              disabled={loading}
            >
              <span>{loading ? 'Sending...' : 'Submit'}</span>
              <i>
                <img src="/images/icons/arrow_white.svg" alt="Icon" />
                <img src="/images/icons/arrow_white.svg" alt="Icon" />
              </i>
            </button>
          </div>
        </div>
      </form>
    </>
  );
}